

















































import { Prop, Component, Vue } from "vue-property-decorator";
import EstimateService from "@/usecases/accounting/estimate-service";
import PurchaseOption from "../components/PurchaseOption.vue";
import Purchase from "../../../usecases/accounting/purchase";
import EstimatePurchase from "../presenters/estimate-purchase";
import EstimatePurchaseItem from "../presenters/estimate-purchase-item";
import PurchaseOptionHeader from "../components/PurchaseOptionHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import EstimateItem from "../../../usecases/accounting/estimate-item";
import PurchaseItem from "../../../usecases/accounting/purchase-item";
import EstimateApi from "../../../api/accounting/estimate-api";
import { client } from "../../../api/request";
import PurchaseApi from "../../../api/accounting/purchase-api";
import formatDate from "../../../helpers/formatDate";
import PurchaseService from "../../../usecases/accounting/purchase-service";
import { CONSUMPTION_TAX_RATE } from "@/preferences";
import Decimal from "decimal.js";

const estimateApi = new EstimateApi(client);
const purchaseApi = new PurchaseApi(client);

@Component({
  components: {
    VToolbar,
    PurchaseOptionHeader,
    PurchaseOption
  }
})
export default class NewPurchasePage extends Vue {
  @Prop({ required: true }) estimateId!: string;

  estimate = new EstimatePurchase();
  items: EstimatePurchaseItem[] = [];
  andEdit: boolean = true;

  get selectedItems() {
    return selectedItems(this.items);
  }

  protected created() {
    this.initEstimate();
  }

  goPreviousPage() {
    this.$router.push({ name: "estimates" });
  }
  goListPage() {
    this.$router.push({ name: "purchase" });
  }

  private async initEstimate() {
    const estimateService = new EstimateService(estimateApi);
    const estimate = await estimateService.find(Number(this.estimateId));
    this.estimate = new EstimatePurchase(estimate);
    this.items = this.estimate.items.map(
      item => new EstimatePurchaseItem(item)
    );
  }

  async purchase(andEdit: boolean = false) {
    const estimate = {
      ...this.estimate,
      items: purchasingItems(this.selectedItems)
    };
    const estimateSubtotal = estimate.items
      .map(i => new Decimal(i.totalPrice))
      .reduce((sum, p) => sum.plus(p))
      .floor();
    const estimateTax = estimateSubtotal
      .times(new Decimal(estimate.taxRate).div(100))
      .floor();
    const estimateTotal = estimateSubtotal.plus(estimateTax);
    const loss = estimate.items
      .map(i => new Decimal(i.loss))
      .reduce((sum, p) => sum.plus(p))
      .floor();
    const tax = loss.times(new Decimal(estimate.taxRate).div(100)).floor();
    const lossTotal = loss.plus(tax);
    const purchase: Purchase = {
      id: 0,
      title: estimate.title,
      mention: "",
      projectId: estimate.projectId,
      projectName: estimate.projectName,
      staffName: "",
      status: "created",
      statusName: "",
      estimateId: estimate.estimateId,
      estimateTotal: estimateTotal.toNumber(),
      estimateSubtotal: estimateSubtotal.toNumber(),
      estimateTax: estimateTax.toNumber(),
      estimateTaxRate: estimate.taxRate,
      vendorId: 0,
      vendorName: "",
      loss: loss.toNumber(),
      lossTotal: lossTotal.toNumber(),
      tax: tax.toNumber(),
      profit: 0,
      profitRate: 0,
      taxRate: CONSUMPTION_TAX_RATE,
      printsExcludeTax: false,
      items: estimate.items.map(it => this.purchaseItem(it)),
      issuedAt: formatDate(new Date()),
      dateOfIssue: formatDate(new Date())
    };
    new PurchaseService(purchaseApi).calculate(purchase);
    const id = await purchaseApi.save(purchase);
    if (andEdit == true) {
      this.$router.push({
        name: "purchase-edit",
        params: { id: String(id) }
      });
    } else {
      this.initEstimate();
    }
  }

  private purchaseItem(item: EstimateItem): PurchaseItem {
    return {
      ...item,
      id: "",
      estimateItemId: item.id,
      invalid: false,
      items: item.items.map(it => this.purchaseItem(it))
    };
  }
}

function selectedItems(items: EstimatePurchaseItem[]): EstimatePurchaseItem[] {
  return items
    .filter(i => i.selected)
    .map(
      i => new EstimatePurchaseItem({ ...i, items: selectedItems(i.items) })
    );
}

function purchasingItems(
  items: EstimatePurchaseItem[]
): EstimatePurchaseItem[] {
  return items.map(item => {
    const children = purchasingItems(item.items);
    const unitPrice =
      item.items.length > 0
        ? children.reduce((sum, item) => (sum += item.totalPrice), 0)
        : item.unitPrice;
    const totalPrice = unitPrice * item.amount;
    const unitLoss =
      item.items.length > 0
        ? children.reduce((sum, item) => (sum += item.loss), 0)
        : item.unitLoss;
    const loss = unitLoss * item.amount;
    return new EstimatePurchaseItem({
      ...item,
      items: children,
      unitPrice,
      totalPrice,
      unitLoss,
      loss
    });
  });
}
